// ** Icons Import
import {
  Briefcase,
  Calendar,
  Circle,
  Clipboard,
  DollarSign,
  HelpCircle,
  Home,
  MessageSquare,
  Settings,
  User,
  Users,
} from "react-feather";
import {
  checkModuleAdminSetup,
  checkModuleSettingNotification,
  checkModuleSettingRole,
  checkUserRole,
} from "../../views/apps/ecommerce/utils/utils";

export default [
  {
    id: "dashboards",
    title: "Dashboards",
    icon: <Home size={20} />,
    badge: "light-warning",
    // badgeText: '2',
    meta: {
      action: "read",
      resource: "ACL",
    },
    children: [
      {
        id: "company Operation",
        title: "Company Operation",
        icon: <Circle size={12} />,
        navLink: "/apps/dashboard/operation",
        action: "read",
        resource: "ACL",
      },
      {
        id: "notice-board",
        title: "Company Notice",
        icon: <Circle size={12} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/notice-board",
      },
      // {
      //   id: "company-notice",
      //   title: "Company Notice New",
      //   icon: <Circle size={12} />,
      //   action: "read",
      //   resource: "ACL",
      //   navLink: "/apps/company-notice",
      // },
      {
        id: "your-dashboard",
        title: "Your Panel",
        icon: <Circle size={12} />,
        navLink: "/apps/dashboard/private",
        action: "read",
        resource: "ACL",
      },
      {
        id: "Pointing-History",
        title: "Pointing History",
        icon: <Circle size={12} />,
        navLink: "/apps/point",
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "calendar",
    title: "Calendar",
    icon: <Calendar size={20} />,
    navLink: "/apps/calendar",
  },
  {
    id: "workchat",
    title: "WorkChat",
    icon: <MessageSquare size={12} />,
    action: "read",
    resource: "ACL",
    children: [
      {
        id: "dashboards-chat",
        title: "Dashboards",
        icon: <Circle size={12} />,
        navLink: "/apps/chat-dashboard",
        action: "read",
        resource: "ACL",
      },
      {
        id: "message",
        title: "Chat Messages",
        icon: <Circle size={12} />,
        navLink: "/apps/message",
        action: "read",
        resource: "ACL",
      },
      {
        id: "broadcast",
        title: "Quick Reply",
        title: "Quick Reply",
        icon: <Circle size={12} />,
        navLink: "/apps/chat-broadcast",
        action: "read",
        resource: "ACL",
      },
      {
        id: "team",
        title: "Agent Team",
        icon: <Circle size={12} />,
        navLink: "/apps/chat-team",
        action: "read",
        resource: "ACL",
      },
      {
        id: "file-storage",
        title: "File Storage",
        icon: <Circle size={12} />,
        navLink: "/apps/chat-file-storage",
        action: "read",
        resource: "ACL",
      },
      checkUserRole(['admin']) && {
        id: "ai-assistant-setup",
        title: "AI Assistant Setup",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/ai-assistant-setup",
        action: "read",
        resource: "ACL",
      },
      // {
      //   id: "messenger-connect",
      //   title: "Messenger Connect",
      //   icon: <Circle size={12} />,
      //   navLink: "/apps/settings/messenger-connect",
      //   action: "read",
      //   resource: "ACL",
      // },
      {
        id: "contact",
        title: "Contact",
        icon: <Circle size={12} />,
        navLink: `/apps/all-contact`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "list-chat-widget",
        title: "LiveChat Widgets",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/setting-chat-widgets",
        action: "read",
        resource: "ACL",
      },
      // {
      //   id: "livechat",
      //   title: "LiveChat Widget",
      //   icon: <Circle size={12} />,
      //   action: "read",
      //   resource: "ACL",
      //   children: [
      //     {
      //       id: "list-chat-widget",
      //       title: "All Widget",
      //       navLink: "/apps/settings/setting-chat-widgets",
      //       action: "read",
      //       resource: "ACL",
      //     },
      //     {
      //       id: "form-setting-widget",
      //       title: "Widget Setup",
      //       navLink: "/apps/settings/form-chat-widget",
      //       action: "read",
      //       resource: "ACL",
      //     },
      //     {
      //       id: "form-setting-chat",
      //       title: "Theme Setting",
      //       navLink: "/apps/settings/form-setting-chat",
      //       action: "read",
      //       resource: "ACL",
      //     },
      //   ],
      // },
      {
        id: "dashboards-business",
        title: "BroadCast",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/broadcast",
        action: "read",
        resource: "ACL",
      },
      {
        id: "segments-business",
        title: "Clients Segment",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/segmentation",
        action: "read",
        resource: "ACL",
      },
      {
        id: "template",
        title: "Template Message",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/template-message",
        action: "read",
        resource: "ACL",
      },
      {
        id: "template-repository",
        title: "Template Repository",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/template-repository",
        action: "read",
        resource: "ACL",
      },
      {
        id: "history-business",
        title: "History",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/history",
        action: "read",
        resource: "ACL",
      },
      {
        id: "setup-business",
        title: "Setup API",
        icon: <Circle size={12} />,
        navLink: "/apps/whatsapp-business/setup-api",
        action: "read",
        resource: "ACL",
      },
    ],
  },
  // {
  //   id: 'new-events',
  //   title: 'New Events',
  //   icon: <Calendar size={12} />,
  //   action: 'read',
  //   navLink: '/apps/all-events',
  //   resource: 'ACL',
  // },
  // {
  //   id: 'Events',
  //   title: 'Events',
  //   icon: <Calendar size={12} />,
  //   action: 'read',
  //   navLink: '/apps/events',
  //   resource: 'ACL',
  // },
  // checkModuleSettingLeads("leads"),
  {
    id: "leads",
    title: "Leads",
    icon: <Clipboard size={10} />,
    navLink: `/apps/all-leads`,
    action: "read",
    resource: "ACL",
  },
  {
    id: "client",
    title: "Clients",
    icon: <Users size={10} />,
    action: "read",
    resource: "ACL",
    children: [
      {
        id: "clients",
        title: "All Clients",
        icon: <Circle size={12} />,
        navLink: "/apps/clients/all-clients",
        action: "read",
        resource: "ACL",
      },
      // {
      //   id: "clients-view",
      //   title: "Clients view",
      //   icon: <Circle size={12} />,
      //   navLink: "/apps/view-clients",
      //   action: "read",
      //   resource: "ACL",
      // },
      {
        id: "client-project",
        title: "Clients Project",
        icon: <Circle size={12} />,
        navLink: "/apps/client-project",
        action: "read",
        resource: "ACL",
      },
      // {
      //   id: "client-organization",
      //   title: "Client Organization",
      //   icon: <Circle size={12} />,
      //   navLink: "/apps/clients/client-organization",
      //   action: "read",
      //   resource: "ACL",
      // },
      // {
      //   id: "follow-up",
      //   title: "Follow Up",
      //   icon: <Circle size={12} />,
      //   navLink: "/apps/follow-up",
      //   action: "read",
      //   resource: "ACL",
      // },
      {
        id: "client-ticket",
        title: "Client Ticket",
        icon: <Circle size={12} />,
        navLink: "/apps/tickets/all-tickets",
        action: "read",
        resource: "ACL",
      },
      {
        id: "estimates",
        title: "Estimates",
        icon: <Circle size={12} />,
        navLink: "/apps/finance/estimates",
        action: "read",
        resource: "ACL",
      },
      {
        id: "list-proposal",
        title: "Proposal",
        icon: <Circle size={12} />,
        navLink: "/apps/proposals",
        action: "read",
        resource: "ACL",
      },
      {
        id: "client-report",
        title: "Clients Report",
        icon: <Circle size={12} />,
        navLink: "/apps/client-report",
        action: "read",
        resource: "ACL",
      },
    ],
  },

  {
    id: "Work",
    title: "Work",
    icon: <Briefcase size={20} />,
    badge: "light-warning",
    meta: {
      action: "read",
      resource: "ACL",
    },
    children: [
      {
        id: "contracts",
        title: "Contracts",
        icon: <Circle size={12} />,
        navLink: `/apps/work/all-contracts`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "projects",
        title: "Projects",
        icon: <Circle size={12} />,
        meta: {
          action: "read",
          resource: "ACL",
        },
        children: [
          {
            id: "all-projects",
            title: "All Projects",
            icon: <Circle size={12} />,
            navLink: `/apps/work/all-projects`,
            action: "read",
            resource: "ACL",
          },
          {
            id: "my-projects",
            title: "My Projects",
            icon: <Circle size={12} />,
            navLink: `/apps/work/my-projects`,
            action: "read",
            resource: "ACL",
          },
        ]
      },
      {
        id: "tasks",
        title: "Tasks",
        icon: <Circle size={12} />,
        meta: {
          action: "read",
          resource: "ACL",
        },
        children: [
          {
            id: "all-tasks",
            title: "All Tasks",
            icon: <Circle size={12} />,
            navLink: `/apps/work/all-tasks`,
            action: "read",
            resource: "ACL",
          },
          {
            id: "my-tasks",
            title: "My Tasks",
            icon: <Circle size={12} />,
            navLink: `/apps/work/my-tasks`,
            action: "read",
            resource: "ACL",
          },
        ]
      },
      {
        id: "Milestones",
        title: "Milestones",
        icon: <Circle size={12} />,
        meta: {
          action: "read",
          resource: "ACL",
        },
        children: [
          {
            id: "all-milestones",
            title: "All Milestones",
            icon: <Circle size={12} />,
            navLink: "/apps/work/milestones",
            action: "read",
            resource: "ACL",
          },
          {
            id: "my-milestones",
            title: "My Milestones",
            icon: <Circle size={12} />,
            navLink: `/apps/work/my-milestones`,
            action: "read",
            resource: "ACL",
          },
        ]
      },
      {
        id: "timelogs",
        title: "Timelogs",
        icon: <Circle size={12} />,
        navLink: `/apps/work/all-timelogs`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "note-project",
        title: "Notes",
        icon: <Circle size={12} />,
        navLink: `/apps/work/all-notes`,
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "client-milestones",
    title: "Milestones",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/work/milestones",
    action: "read",
    resource: "ACL",
  },
  {
    id: "client-work-app",
    title: "Works Portfolio",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/work-app",
    action: "read",
    resource: "ACL",
  },
  {
    id: "client-team",
    title: "Team Profile",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/team",
    action: "read",
    resource: "ACL",
  },
  {
    id: "client-profile",
    title: "Company",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/profile",
    action: "read",
    resource: "ACL",
  },
  {
    id: "client-service",
    title: "Service",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/service",
    action: "read",
    resource: "ACL",
  },
  {
    id: "client-help-center",
    title: "Knowledge Center",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/help-center",
    action: "read",
    resource: "ACL",
  },

  {
    id: "hr",
    title: "HR",
    icon: <User size={10} />,
    action: "read",
    resource: "ACL",
    children: [
      {
        id: "assets",
        title: "Assets",
        icon: <Circle size={12} />,
        navLink: "/apps/hr/all-assets",
        action: "read",
        resource: "ACL",
      },
      {
        id: "Knowledge",
        title: "Knowledge",
        icon: <Circle size={12} />,
        navLink: `/apps/faq/all-knowledge`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "employees",
        title: "Employees",
        icon: <Circle size={12} />,
        navLink: `/apps/hr/all-employees`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "department",
        title: "Department",
        icon: <Circle size={12} />,
        navLink: "/apps/hr/departments",
        action: "read",
        resource: "ACL",
      },
      {
        id: "designation",
        title: "Designation",
        icon: <Circle size={12} />,
        navLink: "/apps/hr/designations",
        action: "read",
        resource: "ACL",
      },
      // checkModuleSetting("attendance", "hr"),
      {
        id: "attendance",
        title: "attendance",
        icon: <Circle size={12} />,
        navLink: `/apps/hr/all-attendance`,
        action: "read",
        resource: "ACL",
      },
      // checkModuleSetting("leaves", "hr"),
      {
        id: "leaves",
        title: "Leaves",
        icon: <Circle size={12} />,
        navLink: `/apps/hr/all-leaves`,
        action: "read",
        resource: "ACL",
      },
      // checkModuleSetting("holidays", "hr"),
      {
        id: "holidays",
        title: "Holidays",
        icon: <Circle size={12} />,
        navLink: `/apps/hr/all-holidays`,
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "Finance",
    title: "Finance",
    icon: <DollarSign size={20} />,
    badge: "light-warning",
    meta: {
      action: "read",
      resource: "ACL",
    },
    children: [
      // checkModuleSetting("invoices", "finance"),
      {
        id: "invoices",
        title: "Invoices",
        icon: <Circle size={12} />,
        navLink: `/apps/finance/all-invoices`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "invoice-recurring",
        title: "Recurring Invoices",
        icon: <Circle size={12} />,
        navLink: "/apps/finance/invoice-recurring",
        action: "read",
        resource: "ACL",
      },
      // checkModuleSetting("payments", "finance"),
      {
        id: "payments",
        title: "Payments",
        icon: <Circle size={12} />,
        navLink: `/apps/finance/all-payments`,
        action: "read",
        resource: "ACL",
      },
      // checkModuleSetting("expenses", "finance"),
      {
        id: "expenses",
        title: "Expenses",
        icon: <Circle size={12} />,
        navLink: `/apps/finance/all-expenses`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "Expenses Recurring",
        title: "Expenses Recurring",
        icon: <Circle size={12} />,
        navLink: "/apps/finance/expenses-recurring",
        action: "read",
        resource: "ACL",
      },
      // {
      //   id: 'Credit Note',
      //   title: 'Credit Note',
      //   icon: <Circle size={12} />,
      //   navLink: '/finance/all-credit-notes',
      //   action: 'read',
      //   resource: 'ACL'
      // },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    icon: <Settings size={10} />,
    action: "read",
    resource: "ACL",
    children: [
      // {
      //   id: "getting-started",
      //   title: "getting started",
      //   icon: <Circle size={10} />,
      //   action: "read",
      //   resource: "ACL",
      //   navLink: "/apps/settings/getting-started",
      // },

      {
        id: "company-settings",
        title: "Company Profile",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/company-settings",
        action: "read",
        resource: "ACL",
      },
      {
        id: "account-setting",
        title: "Account Profile",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/account-settings",
        action: "read",
        resource: "ACL",
      },
      {
        id: "billing-profile",
        title: "Billing Profile",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/billing",
      },
      {
        id: "company-portal",
        title: "Company Portal",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/company-portal",
      },
      checkModuleSettingRole(),
      checkModuleSettingNotification(),
      // checkModuleSettingAdmin(),
      {
        id: "custom-fields",
        title: "Custom Fields",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/custom-fields",
        action: "read",
        resource: "ACL",
      },
      {
        id: "form-setting-proposal",
        title: "Proposal Setting",
        icon: <Circle size={10} />,
        navLink: "/apps/settings/proposal",
        action: "read",
        resource: "ACL",
      },
      {
        id: "tickets-settings",
        title: "Ticket Setting",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/tickets",
        action: "read",
        resource: "ACL",
      },
      {
        id: "leave-settings",
        title: "Leave Setting",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/leaves-settings",
        action: "read",
        resource: "ACL",
      },
      {
        id: "products",
        title: "Product Setting",
        icon: <Circle size={10} />,
        navLink: `/apps/settings/all-products`,
        action: "read",
        resource: "ACL",
      },
      {
        id: "project-settings",
        title: "Project Setting",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/project-settings",
      },
      {
        id: "taxes",
        title: "Tax Setting",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/taxes",
      },
      {
        id: "form-setting-chat",
        title: "Chat Theme Settings",
        icon: <Circle size={10} />,
        navLink: "/apps/settings/form-setting-chat",
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "app-connect",
    title: "WorkApps",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-app"
        viewBox="0 0 16 16"
      >
        <path d="M11 2a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zM5 1a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4z" />
      </svg>
    ),
    navLink: "/apps/settings/connect",
    action: "read",
    resource: "ACL",
    children: [
      {
        id: "dashboard",
        title: "Dashboards",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect",
      },
      {
        id: "whatsapp",
        title: "WhatsApp",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect-whatsApp",
      },
      {
        id: "shopify",
        title: "Shopify",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect-shopify",
      },
      {
        id: "wordpress",
        title: "Wordpress",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect-wordpress",
      },
      {
        id: "wix",
        title: "Wix",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect-wix",
      },
      {
        id: "facebook-messenger",
        title: "Facebook Messenger",
        icon: <Circle size={10} />,
        action: "read",
        resource: "ACL",
        navLink: "/apps/settings/connect-messenger",
      },
      {
        id: "apps-workSpace",
        title: "Apps workSpace",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/apps-workSpace",
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "help-desk",
    title: "Help Desk",
    icon: <HelpCircle size={10} />,
    action: "read",
    resource: "ACL",
    children: [
      checkModuleAdminSetup(),
      {
        id: "setup-wizard",
        title: "Setup Wizard",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/setup-wizard",
        action: "read",
        resource: "ACL",
      },
      {
        id: "setup-workchat",
        title: "Setup LiveChat",
        icon: <Circle size={12} />,
        navLink: "/apps/settings/setup-workchat",
        action: "read",
        resource: "ACL",
      },
    ],
  },
  {
    id: "client-setup-wizard",
    title: "Client Wizard",
    icon: <Circle size={12} />,
    navLink: "/apps/client-view/setup-wizard",
    action: "read",
    resource: "ACL",
  },
];
